import { registerSW } from 'virtual:pwa-register';
import { pendingMutationCount } from './queue';

let waiting = false;
let updateSW: ((reloadPage?: boolean) => Promise<void>) | null = null;
const listeners = new Set<(waiting: boolean) => void>();

function publish() {
  listeners.forEach((listener) => listener(waiting));
}

export function subscribeUpdateWaiting(listener: (waiting: boolean) => void) {
  listeners.add(listener);
  listener(waiting);
  return () => listeners.delete(listener);
}

export function registerBinderServiceWorker() {
  updateSW = registerSW({
    immediate: true,
    onNeedRefresh() {
      waiting = true;
      publish();
      void applyWaitingUpdateWhenSafe();
    }
  });
}

export async function applyWaitingUpdateWhenSafe(): Promise<boolean> {
  if (!waiting || !updateSW) return false;
  if ((await pendingMutationCount()) > 0) return false;

  waiting = false;
  publish();
  await updateSW(true);
  return true;
}
